import React from 'react'
import PropTypes from 'prop-types'
import { defaults, isPresent } from 'lodash'
import Icon from 'UI/FontAwesomeIcon'

const TrueIconDefaults = { icon: 'check', type: 'solid', text: '', color: 'green' }
const FalseIconDefaults = { icon: 'times', type: 'solid', text: '', color: 'red' }

const IconDetails = (booleanValue, trueIcon = TrueIconDefaults, falseIcon = FalseIconDefaults) => defaults({
  [true]: { ...TrueIconDefaults, ...trueIcon },
  [1]: { ...TrueIconDefaults, ...trueIcon },
  [false]: { ...FalseIconDefaults, ...falseIcon },
  [0]: { ...FalseIconDefaults, ...falseIcon },
  [undefined]: { ...FalseIconDefaults, ...falseIcon },
  [null]: { ...FalseIconDefaults, ...falseIcon }
}, {})[booleanValue]

const fontSizes = {
  big: '20px',
  normal: '15px',
  small: '10px',
}

const defaultStyles = { display: 'flex', justifyContent: 'center', alignItems: 'center' }

const BooleanIcon = ({ booleanValue, trueIcon, falseIcon, onClick, styles, size }) => {
  const iconDetails = IconDetails(booleanValue, trueIcon, falseIcon)

  return (
    <span style={{ color: iconDetails.color, fontSize: fontSizes[size], ...defaultStyles, ...styles }} onClick={onClick}>
      <Icon {...iconDetails} /> {isPresent(iconDetails.text) ? <span style={{ marginLeft: '5px' }}>{iconDetails.text}</span> : ''}
    </span>
  )
}

BooleanIcon.propTypes = {
  onClick: PropTypes.func,
  booleanValue: PropTypes.bool.isRequired,
  trueIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  falseIcon: PropTypes.shape({ icon: PropTypes.string, type: PropTypes.string, text: PropTypes.string }),
  styles: PropTypes.shape(PropTypes.any)
}

BooleanIcon.defaultProps = {
  onClick: () => undefined,
  trueIcon: TrueIconDefaults,
  falseIcon: FalseIconDefaults,
  styles: defaultStyles,
  size: 'normal'
}

export default BooleanIcon
